import * as React from "react";
import { Box } from "@mui/system";
import Typography from "@mui/material/Typography";
import { Grid } from "@mui/material";
import { useStyles } from "../../events/styles/index.styles";
import { useTranslation } from "react-i18next";
import MyEventStatus from "./MyEventStatus";
import TitleAndDivider from "../../events/components/TitleAndDivider";
import palette from "../../common/styles/palette";
import moment from "moment";
import "moment/locale/pt-br";
import { getEventTypeName } from "../../events/utils/eventTypes";

/** Mesma linha rótulo/valor de "Dados gerais" da tela do professor. */
const rowSx = {
  color: palette.text,
  "& strong": { fontWeight: 600 },
} as const;

export default function General({ event }: any) {
  const styles = useStyles();
  const { t } = useTranslation();

  React.useEffect(() => {}, [event]);

  return (
    <Box className={styles.container}>
      <TitleAndDivider title={t("overview_data")} />

      <Box className={styles.container}>
        <MyEventStatus status={event?.status} />
        <Grid
          sx={{ mt: 3, mb: 4 }}
          container
          spacing={3}
          className={styles.eventOverviewBody}
        >
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="body2" sx={rowSx}>
              <strong>{t("label_form_event_date")}: </strong>
              {moment(event?.date).locale("pt-br").format("DD/MM/YYYY")}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="body2" sx={rowSx}>
              <strong>{t("input_label_event_type")}: </strong>
              {getEventTypeName(event?.type, t)}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="body2" sx={rowSx}>
              <strong>{t("table_label_entity")}: </strong>
              {event?.entity_name}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="body2" sx={rowSx}>
              <strong>{t("input_label_studentsgroup")}: </strong>
              {event?.studentsgroup_name}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
